import React from 'react'
import styles from './TimesCard.module.scss'
import Grid from '@material-ui/core/Grid'

import TimeItem from './TimeItem'
import { H3 } from '../../../../components/UI'
import { ReactComponent as Sun } from '../../../../assets/svgs/sun.svg'
import { ReactComponent as Moon } from '../../../../assets/svgs/moon.svg'
import { ReactComponent as ArrowUp } from '../../../../assets/svgs/arrow_up.svg'
import I18n from 'i18n-js'

const TimesCard = (props) => {
	return (
		<div className={styles.Card}>
			<div className={styles.CardHeaderContainer}>
				<div className={styles.CardHeaderRight}>
					<div>
						{props.time === 'AM' ? <Sun with={20} height={20}/> : <Moon with={20} height={20}/>}

					</div>
					<div>
						<div className={styles.title}>

							{props.time === 'AM' ? <H3>{I18n.t('consultant.am')}</H3> :
								<H3>{I18n.t('consultant.pm')}</H3>}
						</div>
					</div>
				</div>
				<div>
					<ArrowUp with={24} height={24}/>
				</div>
			</div>
			<div>
				<Grid container spacing={1}>
					{props.timeRanges.map(timeRange => (
						<Grid item xs={6} md={6} key={timeRange.start_at}>
							<TimeItem
								timeRange={timeRange}
								active={timeRange.start_at === props.value}
								onClick={() => {
									props.clicked(timeRange)
								}}
							/>
						</Grid>
					))}
				</Grid>
			</div>
		</div>
	)
}

export default TimesCard
